export default "__VITE_ASSET__BGKAm7kX__"